// extracted by mini-css-extract-plugin
export default {"experts":"styles_experts__0VzVh","description":"styles_description__yx-DW","avatars":"styles_avatars__d26Jy"};